import React from "react";
import MobileLogo from "../../atoms/MobileLogo";
import { Link } from "@quintype/components";
import HamburgerIcon from "../../icons/hamburger";
import "./styles.m.css";

function NavBar(props) {
  return (
    <div styleName="navbar" id="top">
      <div styleName="leftSpace"></div>
      <Link href="/">
        <MobileLogo />
      </Link>
      <a href="#footer-menu">
        <HamburgerIcon />
      </a>
    </div>
  );
}
export { NavBar };
